import { IPostConceptConfiguration, updateConceptConfiguration } from '@cbgms/api/support/conceptConfiguration/apis'
import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

export function useUpdateConceptConfiguration() {
  const dispatch = useDispatch()

  return useMutation(async ({ ...body }: IPostConceptConfiguration) => {
    const response = await dispatch(updateConceptConfiguration(body))
    return response
  })
}
